import classNames from 'classnames';
import { useCallback, useMemo } from 'react';

import { FiltersGrey, Tab, Tabs } from 'common/components';

import { useBowser } from 'common/hooks';

import { DropdownOption, DropdownOptionValue } from './Dropdown.component';

interface DropdownSwitcherProps<T> {
  option: DropdownOption<T>;
  onClick: (tabId?: string) => void;
  isActive?: boolean;
}

export const DropdownSwitcher = <T extends DropdownOptionValue>({
  option,
  isActive = false,
  onClick,
}: DropdownSwitcherProps<T>) => {
  const className = classNames({
    dropdown__item: true,
    'dropdown__item--switcher': true,
    'dropdown__item--active': isActive,
  });

  const tabs = useMemo<Tab[]>(
    () =>
      (option?.options ?? []).map?.(({ label, value, onSelect }) => ({
        label,
        id: value?.toString() ?? null,
        value,
        onClick: onSelect,
      })),
    [option?.options],
  );

  const { isMobile } = useBowser();

  const onTabChangeHandler = useCallback((tabId: string | null) => onClick(tabId || undefined), [onClick]);

  if (!option || option.hidden) return null;

  return (
    <div data-id={option['data-test']} data-test='dropdown-option' className={className}>
      {option.label}

      {isMobile ? (
        <FiltersGrey
          className='dashboards-card__tabs'
          tabs={tabs}
          activeTab={option.value?.toString() ?? null}
          onTabChange={onTabChangeHandler}
        />
      ) : (
        <Tabs
          className='chart-timeframes__tabs--desk'
          tabs={tabs}
          activeTab={option.value?.toString() ?? null}
          onTabChange={onTabChangeHandler}
        />
      )}
    </div>
  );
};
